import { useState } from "react";
import "./schedule.scss";
import AdminNav from "../AdminNav/AdminNav";

const Schedule = () => {
  const [showForm, setShowForm] = useState(false);
  const [meetings, setMeetings] = useState([]);
  const [formData, setFormData] = useState({
    weekday: "",
    date: "",
    start: "",
    end: "",
    Topic:"",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.weekday || !formData.date || !formData.start || !formData.end) {
      alert("Please fill all fields");
      return;
    }

    setMeetings([...meetings, formData]);
    setFormData({ weekday: "", date: "", start: "", end: "" , Topic:"" });
    setShowForm(false);
  };

  return (
    <div className="schedule">
      {/* Create Meeting Button */}
      <div className="top-bar">
         <div className="adminNav">
        <AdminNav/>
        </div>
        <button onClick={() => setShowForm(!showForm)}>
          {showForm ? "Close" : "Create Meeting"}
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
        <form className="meeting-form" onSubmit={handleSubmit}>
          <label>
            Weekday:
            <select name="weekday" value={formData.weekday} onChange={handleChange}>
              <option value="">Select</option>
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
              <option value="Saturday">Saturday</option>
              <option value="Sunday">Sunday</option>
            </select>
          </label>

          <label>
            Date:
            <input type="date" name="date" value={formData.date} onChange={handleChange} />
          </label>

          <label>
            Start Time:
            <input type="time" name="start" value={formData.start} onChange={handleChange} />
          </label>

          <label>
            End Time:
            <input type="time" name="end" value={formData.end} onChange={handleChange} />
          </label>

          <label>
            Topic:
            <input type="text" name="Topic" value={formData.Topic} onChange={handleChange} />
          </label>

          <button type="submit">Create</button>
        </form>
        </div>
        </div>
      )}

      {/* Meeting List */}
      <div className="meeting-list">
        {meetings.length === 0 ? (
          <p>No meetings scheduled yet.</p>
        ) : (
          meetings.map((m, index) => (
            <div className="meeting-card" key={index}>
            <div className="meeting-header">
                <h3>{m.Topic || "Untitled Meeting"}</h3>
                <span className="meeting-day">{m.weekday}</span>
            </div>
            <div className="meeting-body">
                <p><strong>Date:</strong> {m.date}</p>
                <p><strong>Time:</strong> {m.start} - {m.end}</p>
            </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Schedule;
